import { render, staticRenderFns } from "./IncomeDataReport.vue?vue&type=template&id=4e9d86f6&scoped=true"
import script from "./IncomeDataReport.vue?vue&type=script&lang=js"
export * from "./IncomeDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d86f6",
  null
  
)

export default component.exports